import React from "react";
import { Row, Col, Table } from "antd";
import { formatNumberWithCommas } from "../../helpers/formatters";

const AggregatedTable = ({ aggregatedArrayData }) => {
  const dataWithKeyIndex = aggregatedArrayData.map((data, index) => ({
    ...data,
    key: index,
  }));
  const columns = [
    {
      title: "Source",
      dataIndex: "source",
      key: "source",
    },
    {
      title: "Orders",
      dataIndex: "call_count",
      key: "call_count",
      render: (text) => formatNumberWithCommas(text),
    },
    {
      title: "Success Count",
      dataIndex: "success_count",
      key: "success_count",
      render: (text) => formatNumberWithCommas(text),
    },
    {
      title: "Failure Count",
      dataIndex: "failure_count",
      key: "failure_count",
      render: (text) => formatNumberWithCommas(text),
    },
    {
      title: "ValProPDF Success",
      dataIndex: "valpro_pdf_success_count",
      key: "valpro_pdf_success_count",
      render: (text) => formatNumberWithCommas(text),
    },
    {
      title: "ValProPDF Failure",
      dataIndex: "valpro_pdf_fail_count",
      key: "valpro_pdf_fail_count",
      render: (text) => formatNumberWithCommas(text),
    },
    {
      title: "Success Rate (%)",
      key: "success_rate",
      render: (text, record) => {
        const rate =
          record.call_count > 0
            ? ((record.success_count / record.call_count) * 100).toFixed(2)
            : 0;
        return `${rate}%`;
      },
    },
    {
      title: "Failure Rate (%)",
      key: "failure_rate",
      render: (text, record) => {
        const rate =
          record.call_count > 0
            ? ((record.failure_count / record.call_count) * 100).toFixed(2)
            : 0;
        return `${rate}%`;
      },
    },
  ];
  return (
    <Row
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "0 auto",
      }}
    >
      <Col span={24} style={{ overflowX: "auto" }}>
        <Table
          dataSource={dataWithKeyIndex}
          columns={columns}
          rowKey="key"
          pagination={false}
          scroll={{ x: "max-content" }} // Enables horizontal scrolling for mobile screens
          style={{ width: "100%" }} // Makes the table fully responsive
        />
      </Col>
    </Row>
  );
};

export default AggregatedTable;
